"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hasKey = (obj, prop) => {
    return (typeof obj === 'object' &&
        obj !== null &&
        Object.prototype.hasOwnProperty.call(obj, prop));
};
const packageErrors = (errors) => {
    const messages = [];
    errors.forEach((error) => {
        if (hasKey(error, 'message') && typeof error.message === 'string') {
            messages.push(error.message);
        }
    });
    return messages;
};
class GqlError extends Error {
    constructor(operationName, errors) {
        super(`GQL Errors occurred during ${operationName}`);
        this.operationName = operationName;
        this.errors = errors;
    }
    getErrorMessages() {
        return packageErrors(this.errors);
    }
}
exports.default = GqlError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR3FsRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvdHlwZXMvR3FsRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxNQUFNLE1BQU0sR0FBRyxDQUNiLEdBQU0sRUFDTixJQUFTLEVBQ3dCLEVBQUU7SUFDbkMsT0FBTyxDQUNMLE9BQU8sR0FBRyxLQUFLLFFBQVE7UUFDdkIsR0FBRyxLQUFLLElBQUk7UUFDWixNQUFNLENBQUMsU0FBUyxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUNoRCxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsTUFBTSxhQUFhLEdBQUcsQ0FDcEIsTUFBOEIsRUFDUCxFQUFFO0lBQ3pCLE1BQU0sUUFBUSxHQUFhLEVBQUUsQ0FBQztJQUM5QixNQUFNLENBQUMsT0FBTyxDQUFDLENBQUMsS0FBSyxFQUFFLEVBQUU7UUFDdkIsSUFBSSxNQUFNLENBQUMsS0FBSyxFQUFFLFNBQVMsQ0FBQyxJQUFJLE9BQU8sS0FBSyxDQUFDLE9BQU8sS0FBSyxRQUFRLEVBQUU7WUFDakUsUUFBUSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7U0FDOUI7SUFDSCxDQUFDLENBQUMsQ0FBQztJQUNILE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUMsQ0FBQztBQUVGLE1BQXFCLFFBQVMsU0FBUSxLQUFLO0lBQ3pDLFlBQ1MsYUFBcUIsRUFDckIsTUFBOEI7UUFFckMsS0FBSyxDQUFDLDhCQUE4QixhQUFhLEVBQUUsQ0FBQyxDQUFDO1FBSDlDLGtCQUFhLEdBQWIsYUFBYSxDQUFRO1FBQ3JCLFdBQU0sR0FBTixNQUFNLENBQXdCO0lBR3ZDLENBQUM7SUFFTSxnQkFBZ0I7UUFDckIsT0FBTyxhQUFhLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3BDLENBQUM7Q0FDRjtBQVhELDJCQVdDIn0=